import { render, staticRenderFns } from "./ViewCustomersOld.vue?vue&type=template&id=5ec4961e&"
import script from "./ViewCustomersOld.vue?vue&type=script&lang=js&"
export * from "./ViewCustomersOld.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomersOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports